import { render, staticRenderFns } from "./SkillIcon.vue?vue&type=template&id=33126910&scoped=true&"
import script from "./SkillIcon.vue?vue&type=script&lang=js&"
export * from "./SkillIcon.vue?vue&type=script&lang=js&"
import style0 from "./SkillIcon.vue?vue&type=style&index=0&id=33126910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33126910",
  null
  
)

export default component.exports